export default {
  getShiftOfADivisionOfASemester: '/semester/getShiftOfADivisionOfASemester',
  getNameOfASemester: '/semester/getNameOfASemester',
  getDivisionsOfASemester: '/semester/getDivisionsOfASemester',
  getNamesOfSemesters: '/semester/getNamesOfSemesters',
  getSemestersBySemId: '/semester/getSemestersBySemId'
}
